import { Tooltip } from "@material-ui/core";
import FlexRow from "../../../../../../components/FlexBox/FlexRow";
import Checkbox from "../../../../../../components/Inputs/Checkbox/Checkbox";
import Typography from "../../../../../../components/Typography/Typography";
import styles from './Mesh.module.scss';
import classnames from 'classnames';

const MeshChannel = ({ pinData, isEditable, isTextChangeable, onTextChange, handleChange, left = true }) => {

    return (
        <FlexRow justifyContent="start" flexWrap="nowrap" styles={{ border: '1px solid var(--grey-500)', marginLeft: left ? '0.5rem' : '-1rem', paddingRight: left ? '0.5rem' : '-1rem', borderRadius: '0.5rem', overflow: 'hidden' }}>
            <Checkbox
                disabled={pinData.type === 'DO'}
                checked={pinData.isEnabled}
                onChange={() => {
                    if (isEditable) handleChange(pinData.id, !pinData.isEnabled);
                }}
                onlyCheckBox={true}
                containerStyles={{ margin: '1rem', marginLeft: left ? '0.5rem' : '1rem', top: '0.5rem' }}
            />
            {isTextChangeable && pinData?.type !== 'DO' ? (
                <input
                    disabled={pinData?.type === 'DO'}
                    name="name"
                    type="text"
                    onChange={(e) => {
                        onTextChange && onTextChange(pinData?.id, e.target.value);
                    }}
                    value={pinData?.name}
                    className={classnames(styles['mrgt-02'], styles['mesh_input'])}
                />
            ) : (
                <Tooltip enterTouchDelay={0} interactive={true} title={pinData?.name} placement="top" style={{background:'red'}} arrow>
                    <Typography style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%' }} variant={"b3R"}>{pinData?.name}</Typography>
                </Tooltip>
            )}
        </FlexRow>
    )
};

export default MeshChannel;